"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSafeTimeout = void 0;
const react_1 = require("react");
const clearTimeouts = (timers) => timers.forEach((timer) => clearTimeout(timer));
function useSafeTimeout() {
    const timers = (0, react_1.useRef)([]);
    (0, react_1.useEffect)(() => () => {
        clearTimeouts(timers.current);
    }, []);
    return (handler, timeout) => {
        const timer = setTimeout(() => {
            timers.current = timers.current.filter((item) => item !== timer);
            handler();
        }, timeout);
        timers.current.push(timer);
    };
}
exports.useSafeTimeout = useSafeTimeout;
